export default __webpack_public_path__ + "static/media/logo-wholesale.368da8c2.png";